import React, { useMemo } from "react";
import Heading from "@druva-apps/orion/lib/heading";
import Input from "@druva-apps/orion/lib/input";
import Form from "@druva-apps/orion/lib/form";
import FormGroup from "@druva-apps/orion/lib/formGroup";
import Button from "@druva-apps/orion/lib/button";

import BackButton from "../BackButton";
import FormCardBody from "../FormCardBody";
import styles from "../FormContainer.module.scss";

const schema = (Yup) =>
  Yup.object().shape({
    phoneNumber: Yup.string()
      .trim()
      .min(8, "Enter a valid mobile number")
      .required("Required"),
    consent: Yup.bool().oneOf([true], "Consent is required"),
  });

const RegisterMobileForm = ({
  onSubmit,
  onBack,
  isSubmitting,
  disableSubmit = false,
  compact = false,
}) => {
  const initialValues = useMemo(
    () => ({ phoneNumber: "", consent: false }),
    []
  );

  return (
    <FormCardBody
      compact={compact}
      footer={
        <BackButton
          dataTestId="login-regmobile-back-btn"
          onClick={onBack}
          label="Back"
        />
      }
    >
      <Heading
        type="4"
        text="Register mobile number"
        className="oui-font-weight-normal oui-mt-2 oui-mb-3 oui-text-center"
        dataTestId="login-regmobile-title"
      />
      <p className="oui-text-secondary oui-small oui-mb-3">
        SMS based Multi-Factor Authentication is enabled for your organization.
        Register your mobile number to receive OTP.
      </p>
      <Form
        validationSchema={schema}
        withValidation
        initialValues={initialValues}
        onSubmit={onSubmit}
        className={styles.formContainer}
        renderChildren={(props) => (
          <>
            <FormGroup className={`${styles.input} oui-mb-2`}>
              <Input
                type="tel"
                name="phoneNumber"
                placeholder="+1 5550100123"
                validationProps={props}
                isInvalid={
                  props.touched.phoneNumber &&
                  props.errors.phoneNumber !== undefined
                }
                data-testid="login-regmobile-phone"
              />
            </FormGroup>
            <FormGroup className="oui-mb-3">
              <label className="oui-d-flex oui-align-items-start">
                <Input
                  type="checkbox"
                  name="consent"
                  validationProps={props}
                  data-testid="login-regmobile-consent"
                />
                <span className="oui-ml-2 oui-small">
                  By entering your phone number you consent to receive OTP on
                  messages.
                </span>
              </label>
              {props.touched.consent && props.errors.consent ? (
                <div className="oui-text-danger oui-small oui-mt-1">
                  {props.errors.consent}
                </div>
              ) : null}
            </FormGroup>
            <Button
              label="Send OTP"
              dataTestId="login-regmobile-send-btn"
              size="lg"
              block
              type="primary"
              onClick={() => {
                props.setFieldTouched("consent", true);
                props.submitForm();
              }}
              className="oui-mb-3"
              disabled={
                !props.isValid ||
                !props.values.consent ||
                isSubmitting ||
                disableSubmit
              }
            />
          </>
        )}
      />
    </FormCardBody>
  );
};

export default RegisterMobileForm;
